import { getApiBaseUrl } from './apiUtils';

// TypeScript Interfaces
export interface VnrRevenueSummaryData {
  total_emails: number;
  emails_with_revenue: number;
  total_revenue: number;
  avg_revenue_per_email: number;
  avg_revenue_per_customer: number;
  conversion_rate: number;
}

export interface VnrRevenueTimelineData {
  month: string;
  signups: number;
  revenue: number;
}

export interface VnrSourceAnalysisData {
  source: string;
  emails: number;
  emails_with_revenue: number;
  total_revenue: number;
  avg_revenue_per_email: number;
  avg_revenue_per_customer: number;
  conversion_rate: number;
}

export interface VnrNewsletterAnalysisData {
  newsletter: string;
  emails: number;
  emails_with_revenue: number;
  total_revenue: number;
  avg_revenue_per_email: number;
  conversion_rate: number;
}

export interface VnrDomainAnalysisData {
  email_domain: string;
  emails: number;
  emails_with_revenue: number;
  total_revenue: number;
  avg_revenue_per_email: number;
  conversion_rate: number;
}

// API Fetch Functions

export async function fetchVnrRevenueSummary(
  leadStartDate: string,
  leadEndDate: string,
  revenueStartDate: string,
  revenueEndDate: string,
  sources: string[],
): Promise<VnrRevenueSummaryData> {
  const sourcesParam = sources.join(',');
  const url = `${getApiBaseUrl()}/api/vnr-revenue/summary?leadStartDate=${leadStartDate}&leadEndDate=${leadEndDate}&revenueStartDate=${revenueStartDate}&revenueEndDate=${revenueEndDate}&sources=${sourcesParam}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.data;
}

export async function fetchVnrRevenueTimeline(
  leadStartDate: string,
  leadEndDate: string,
  revenueStartDate: string,
  revenueEndDate: string,
  sources: string[],
): Promise<VnrRevenueTimelineData[]> {
  const sourcesParam = sources.join(',');
  const url = `${getApiBaseUrl()}/api/vnr-revenue/timeline?leadStartDate=${leadStartDate}&leadEndDate=${leadEndDate}&revenueStartDate=${revenueStartDate}&revenueEndDate=${revenueEndDate}&sources=${sourcesParam}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.data;
}

export async function fetchVnrSourceAnalysis(
  leadStartDate: string,
  leadEndDate: string,
  revenueStartDate: string,
  revenueEndDate: string,
  sources: string[],
): Promise<VnrSourceAnalysisData[]> {
  const sourcesParam = sources.join(',');
  const url = `${getApiBaseUrl()}/api/vnr-revenue/source-analysis?leadStartDate=${leadStartDate}&leadEndDate=${leadEndDate}&revenueStartDate=${revenueStartDate}&revenueEndDate=${revenueEndDate}&sources=${sourcesParam}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.data;
}

export async function fetchVnrNewsletterAnalysis(
  leadStartDate: string,
  leadEndDate: string,
  revenueStartDate: string,
  revenueEndDate: string,
  sources: string[],
): Promise<VnrNewsletterAnalysisData[]> {
  const sourcesParam = sources.join(',');
  const url = `${getApiBaseUrl()}/api/vnr-revenue/newsletter-analysis?leadStartDate=${leadStartDate}&leadEndDate=${leadEndDate}&revenueStartDate=${revenueStartDate}&revenueEndDate=${revenueEndDate}&sources=${sourcesParam}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.data;
}

export async function fetchVnrDomainAnalysis(
  leadStartDate: string,
  leadEndDate: string,
  revenueStartDate: string,
  revenueEndDate: string,
  sources: string[],
): Promise<VnrDomainAnalysisData[]> {
  const sourcesParam = sources.join(',');
  const url = `${getApiBaseUrl()}/api/vnr-revenue/domain-analysis?leadStartDate=${leadStartDate}&leadEndDate=${leadEndDate}&revenueStartDate=${revenueStartDate}&revenueEndDate=${revenueEndDate}&sources=${sourcesParam}`;
  const response = await fetch(url);
  const result = await response.json();
  return result.data;
}
